import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import { setUserPermissions, setPortalSettingInfo } from "../reducers/userPermissions";

export function getUserPermissions(data: any) {
  return (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/permissions/getUserPermissions`, data).then((response: any) => {
      if (response && response.data.status) {
        dispatch(setUserPermissions(response.data.data));
      }
    });
  };
}
export const getNotificationPreference = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/userSettings/getNotificationPreference`, data);
  return response;
};

export function getPortalSetting() {
  return async (dispatch: any) => {
    const responseData = await axiosWrapper.get(`${getBackendUrl()}/portal/getPortalSettingsObject`);
    if (responseData.status) {
      dispatch(setPortalSettingInfo(responseData.data.data));
    }
  };
}
export const saveUserSettings = async (data: any) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/saveUserSettings`, data);
  return response;
};
export const getUserSettings = async (data: any) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/getUserSettings`, data);
  return response;
};
export const deleteUserSettings = async (data: any) => {
  const response = axiosWrapper.post(`${getBackendUrl()}/userSettings/deleteUserSettings`, data);
  return response;
};
